import React, { useState, useEffect, useRef } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

export default function RevealValue({
    value,
    format = '',
    initiallyMasked = true,
    autoHideMs = null,
}) {
    const formatted = format + value;
    const [masked, setMasked] = useState(Boolean(initiallyMasked));
    const [maskWidth, setMaskWidth] = useState(0);
    const measureRef = useRef(null);

    // Measure width of the balance (hidden span) whenever value changes
    useEffect(() => {
        setMaskWidth(measureRef.current.offsetWidth);
    }, [formatted]);

    // Auto-hide timer
    useEffect(() => {
        let timer;
        if (!masked && autoHideMs && autoHideMs > 0) {
            timer = setTimeout(() => setMasked(true), autoHideMs);
        }
        return () => clearTimeout(timer);
    }, [masked, autoHideMs]);

    const toggleMask = () => setMasked((m) => !m);

    return (
        <div className="reveal-wrapper">
            <span
                className="balance-text balance-value"
                ref={measureRef}
                style={{
                    position: 'absolute',
                    visibility: 'hidden',
                }}
            >
                {formatted}
            </span>

            <div
                className={`balance-text ${masked ? 'masked' : 'visible'}`}
                style={masked ? { width: maskWidth } : {}}
            >
                {masked ? (
                    <div className="signal-mask">
                        <div className="mask-shimmer"></div>
                    </div>
                ) : (
                    <span className="balance-value">{formatted}</span>
                )}
            </div>

            <button
                className={`eye-btn ${!masked ? 'active' : ''}`}
                onClick={toggleMask}
                aria-label={masked ? 'Show value' : 'Hide value'}
            >
                {masked ? <FiEye className="eye-icon" /> : <FiEyeOff className="eye-icon" />}
            </button>
        </div>
    );
}
